import React, { FC, ReactElement, ReactNode } from 'react'
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'
import Skeleton from '@material-ui/lab/Skeleton'

type Props = {
    /** Number of skeleton body rows to render. */
    noRows: number
    /** Number of data columns (must match {@link DataTable} column definitions). */
    dataColumnCount: number
    /** When true, prepends a checkbox-width cell so rows align with selectable tables. */
    includeSelectionColumn?: boolean
}

/**
 * Placeholder rows shown while table data is loading. Column count must match the head row
 * (including an extra cell when the table is selectable) or headers and body misalign.
 */
export const DataTableRowLoader: FC<Props> = ({
    noRows,
    dataColumnCount,
    includeSelectionColumn = false
}: Props): ReactElement => (
    <>
        {[...Array<number>(noRows)].map(
            (_row: number, index: number): ReactNode => (
                <TableRow className='rd-table-row rd-table-loader' key={`rd-table-row-loader-${index}`}>
                    {includeSelectionColumn ? (
                        <TableCell
                            padding='checkbox'
                            key='rd-table-loader-selection'
                            className='router-datatable-body-selection-cell'
                        />
                    ) : null}
                    {[...Array<number>(dataColumnCount)].map(
                        (_col: number, idx: number): ReactElement => (
                            <TableCell key={`rd-table-column-loader-${String(idx)}`} align='left'>
                                <Skeleton variant='text' />
                            </TableCell>
                        )
                    )}
                </TableRow>
            )
        )}
    </>
)
